import { account } from '@/lib/appwrite'
import { defineStore } from 'pinia'

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        user: null,
        isLoading: true,
    }),
    getters: {
        isLoggedIn() {
            return !!this.user;
        },
    },
    actions: {
        async init() {
            this.isLoading = true;
            try {
                // Check if we're on an OAuth callback with parameters
                const urlParams = new URLSearchParams(window.location.search);
                
                // If we have OAuth parameters, don't try to get user yet - 
                // let the OAuth callback component handle session creation
                if (urlParams.has('userId') && urlParams.has('secret')) {
                    return; // Exit early, let OAuth callback handle this
                }
                
                // Try to get existing user session
                this.user = await account.get();
            } catch (error) {
                if (error.code !== 401) {
                    console.error('Error initializing auth:', error);
                }
                this.user = null;
            } finally {
                this.isLoading = false;
            }
        },
        async login() {
            if (this.isLoggedIn) {
                console.log('User is already logged in');
                return;
            }
            try {
                const currentDomain = window.location.origin;
                
                console.log('Current domain:', currentDomain);
                // Use token-based OAuth flow for better browser compatibility
                account.createOAuth2Token(
                    'microsoft', 
                    `${currentDomain}/auth/success`, 
                    `${currentDomain}/auth/failure`
                );
            } catch (error) {
                console.error('Login failed:', error);
                throw error;
            }
        },
        async logout() {
            try {
                await account.deleteSession('current');
                this.user = null;
            } catch (error) {
                console.error('Logout failed:', error);
                throw error;
            }
        },
        
        async handleOAuthSuccess() {
            try {
                // Extract userId and secret from URL parameters
                const urlParams = new URLSearchParams(window.location.search);
                const userId = urlParams.get('userId');
                const secret = urlParams.get('secret');
                
                if (!userId || !secret) {
                    console.error('Missing OAuth parameters');
                    return false;
                }
                
                // Create session using the token parameters
                await account.createSession(userId, secret);
                
                // Fetch user data
                this.user = await account.get();
                
                // Clear URL parameters
                window.history.replaceState({}, document.title, window.location.pathname);
                
                return true;
            } catch (error) {
                console.error('OAuth success handling failed:', error);
                return false;
            }
        },
        
        handleOAuthFailure() {
            this.user = null;
            const urlParams = new URLSearchParams(window.location.search);
            const error = urlParams.get('error') || 'Authentication failed';
            return error;
        }
    },
})

export default useAuthStore